// URL base del backend. En pruebas (staging) se sobreescribe con REACT_APP_API_URL.
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.lajuanita.mx';
